/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authAuthorizationRouteImport } from './routes/(auth)/authorization'
import { Route as redirectViberIndexRouteImport } from './routes/(redirect)/viber/index'
import { Route as redirectTelegramIndexRouteImport } from './routes/(redirect)/telegram/index'
import { Route as redirectLineIndexRouteImport } from './routes/(redirect)/line/index'
import { Route as AuthenticatedPartnerChatBookingIdRouteImport } from './routes/_authenticated/partner-chat.$bookingId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthorizationRoute = authAuthorizationRouteImport.update({
  id: '/(auth)/authorization',
  path: '/authorization',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectViberIndexRoute = redirectViberIndexRouteImport.update({
  id: '/(redirect)/viber/',
  path: '/viber/',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectTelegramIndexRoute = redirectTelegramIndexRouteImport.update({
  id: '/(redirect)/telegram/',
  path: '/telegram/',
  getParentRoute: () => rootRouteImport,
} as any)
const redirectLineIndexRoute = redirectLineIndexRouteImport.update({
  id: '/(redirect)/line/',
  path: '/line/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedPartnerChatBookingIdRoute =
  AuthenticatedPartnerChatBookingIdRouteImport.update({
    id: '/partner-chat/$bookingId',
    path: '/partner-chat/$bookingId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/authorization': typeof authAuthorizationRoute
  '/401': typeof errors401Route
  '/404': typeof errors404Route
  '/partner-chat/$bookingId': typeof AuthenticatedPartnerChatBookingIdRoute
  '/line/': typeof redirectLineIndexRoute
  '/telegram/': typeof redirectTelegramIndexRoute
  '/viber/': typeof redirectViberIndexRoute
}
export interface FileRoutesByTo {
  '/authorization': typeof authAuthorizationRoute
  '/401': typeof errors401Route
  '/404': typeof errors404Route
  '/': typeof AuthenticatedIndexRoute
  '/partner-chat/$bookingId': typeof AuthenticatedPartnerChatBookingIdRoute
  '/line': typeof redirectLineIndexRoute
  '/telegram': typeof redirectTelegramIndexRoute
  '/viber': typeof redirectViberIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/(auth)/authorization': typeof authAuthorizationRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/404': typeof errors404Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/partner-chat/$bookingId': typeof AuthenticatedPartnerChatBookingIdRoute
  '/(redirect)/line/': typeof redirectLineIndexRoute
  '/(redirect)/telegram/': typeof redirectTelegramIndexRoute
  '/(redirect)/viber/': typeof redirectViberIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authorization'
    | '/401'
    | '/404'
    | '/partner-chat/$bookingId'
    | '/line/'
    | '/telegram/'
    | '/viber/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/authorization'
    | '/401'
    | '/404'
    | '/'
    | '/partner-chat/$bookingId'
    | '/line'
    | '/telegram'
    | '/viber'
  id:
    | '__root__'
    | '/_authenticated'
    | '/(auth)/authorization'
    | '/(errors)/401'
    | '/(errors)/404'
    | '/_authenticated/'
    | '/_authenticated/partner-chat/$bookingId'
    | '/(redirect)/line/'
    | '/(redirect)/telegram/'
    | '/(redirect)/viber/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authAuthorizationRoute: typeof authAuthorizationRoute
  errors401Route: typeof errors401Route
  errors404Route: typeof errors404Route
  redirectLineIndexRoute: typeof redirectLineIndexRoute
  redirectTelegramIndexRoute: typeof redirectTelegramIndexRoute
  redirectViberIndexRoute: typeof redirectViberIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/authorization': {
      id: '/(auth)/authorization'
      path: '/authorization'
      fullPath: '/authorization'
      preLoaderRoute: typeof authAuthorizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirect)/viber/': {
      id: '/(redirect)/viber/'
      path: '/viber'
      fullPath: '/viber/'
      preLoaderRoute: typeof redirectViberIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirect)/telegram/': {
      id: '/(redirect)/telegram/'
      path: '/telegram'
      fullPath: '/telegram/'
      preLoaderRoute: typeof redirectTelegramIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(redirect)/line/': {
      id: '/(redirect)/line/'
      path: '/line'
      fullPath: '/line/'
      preLoaderRoute: typeof redirectLineIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/partner-chat/$bookingId': {
      id: '/_authenticated/partner-chat/$bookingId'
      path: '/partner-chat/$bookingId'
      fullPath: '/partner-chat/$bookingId'
      preLoaderRoute: typeof AuthenticatedPartnerChatBookingIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedPartnerChatBookingIdRoute: typeof AuthenticatedPartnerChatBookingIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedPartnerChatBookingIdRoute:
    AuthenticatedPartnerChatBookingIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authAuthorizationRoute: authAuthorizationRoute,
  errors401Route: errors401Route,
  errors404Route: errors404Route,
  redirectLineIndexRoute: redirectLineIndexRoute,
  redirectTelegramIndexRoute: redirectTelegramIndexRoute,
  redirectViberIndexRoute: redirectViberIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
